import React, { useEffect, useRef, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';

import { Autocomplete, InputWrapper, Input, SelectorLoading } from './styles';

function Selector({
  name,
  label,
  idColumn,
  nameColumn,
  options,
  onChange,
  loading,
  required,
  ...rest
}) {
  const { fieldName, registerField, error, clearError } = useField(name);

  const [value, setValue] = useState(null);

  const inputRef = useRef({ value: '' });

  const handleChange = useCallback(
    newValue => {
      setValue(newValue);

      if (inputRef.current)
        if (newValue) inputRef.current.value = newValue[idColumn];
        else inputRef.current.value = '';

      if (onChange) onChange(newValue);

      if (error) clearError();
    },
    [idColumn, onChange, error, clearError]
  );

  useEffect(() => {
    inputRef.current.handleChange = handleChange;

    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField, handleChange]);

  return (
    <Autocomplete
      options={options}
      value={value}
      onChange={(event, newValue) => handleChange(newValue)}
      getOptionLabel={option => option[nameColumn]}
      getOptionSelected={option => option}
      loading={loading}
      variant="outlined"
      size="small"
      renderInput={params => (
        <InputWrapper error={!!error}>
          {loading && <SelectorLoading />}
          <Input
            {...params}
            label={
              <p>
                {label} {required && <b style={{ color: '#d50000' }}>*</b>}
              </p>
            }
            variant="outlined"
            error={!!error}
            helperText={error || ' '}
          />
        </InputWrapper>
      )}
      {...rest}
    />
  );
}

export default Selector;

Selector.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  idColumn: PropTypes.string.isRequired,
  nameColumn: PropTypes.string.isRequired,
  options: PropTypes.instanceOf(Array).isRequired,
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  required: PropTypes.bool,
};

Selector.defaultProps = {
  onChange: null,
  loading: false,
  required: false,
};
